import React from 'react'

// Elements
import ParseContent from 'components/shared/ParseContent'
import FlexContentHandler from 'components/shared/FlexContentHandler'
import Share from 'components/elements/Share'

// Third Party
import styled from 'styled-components'
import usePost from 'hooks/usePost'
import Plaatjie from '@ubo/plaatjie'

interface WithImageProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
  location?: any
  pageContext?: any
}

const StyledWithImage = styled.div`
  & p,
  li {
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.color.grey};

    & b,
    strong {
      /* color: ${({ theme }) => theme.color.darkish}; */
      color: inherit;
    }
  }

  & a {
    color: ${({ theme }) => theme.color.primary};

    &:hover {
      text-decoration: underline;
    }
  }

  & img {
    object-fit: contain !important;
  }

  & li {
    list-style: none;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      margin-top: auto;
      margin-bottom: auto;
      left: -20px;
      background-color: ${({ theme }) => theme.color.primary};
      height: 8px;
      width: 8px;
      border-radius: 4px;
    }
  }

  & blockquote {
    padding: 80px 0 20px 60px;
    position: relative;

    & em {
      font-size: 24px !important;
    }

    & p {
      font-size: 15px !important;
      color: ${({ theme }) => theme.color.darkish};
      font-family: ${({ theme }) => theme.font.family.secondary};
      font-weight: ${({ theme }) => theme.font.weight.bold};
      padding-bottom: 20px;

      &:first-of-type {
        line-height: 34px;
      }

      & b,
      strong {
        color: ${({ theme }) => theme.color.primary};
        font-size: 16px;
        line-height: 140%;
      }
    }

    &::before {
      content: '“';
      position: absolute;
      font-family: ${({ theme }) => theme.font.family.secondary};
      font-weight: ${({ theme }) => theme.font.weight.bold};
      font-size: 165px;
      top: -50px;
      left: 0;
      color: ${({ theme }) => theme.color.primary};
    }
  }

  & h2 {
    font-size: 20px;
    line-height: 24px;
    font-family: ${({ theme }) => theme.font.family.secondary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding-top: 20px;
  }

  & h3 {
    font-size: 28px;
    line-height: 40px;
    font-family: ${({ theme }) => theme.font.family.secondary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding-bottom: 20px;
  }

  @media screen and (max-width: 991px) {
    & blockquote {
      padding: 100px 0 20px 0px;
    }
  }
`

const Image = styled(Plaatjie)`
  border-radius: 25px;
  object-fit: cover !important;
`

const WithImage: React.FC<WithImageProps> = ({ fields }) => {
  return (
    <section className="pt-lg-5">
      <div className="container py-5">
        <div className={`row justify-content-between`}>
          <StyledWithImage
            className={
              'position-relative pb-lg-0 pb-4 col-lg-7 ' +
              (fields?.positionImage === 'left' ? 'ps-lg-4' : 'pe-lg-4')
            }
          >
            <ParseContent content={fields.description} />
          </StyledWithImage>
          <div
            className={
              'col-lg-4 ' +
              (fields?.positionImage === 'left' ? 'order-lg-first' : '')
            }
          >
            <Image image={fields?.image} alt="" className="h-100 w-100" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default WithImage
